<template>
  <div class="ui container">
    <h2 class="ui dividing header">
      <img src="/images/icons/credit_card.png" />
      <div class="content">
        {{ $t("credit card payment") }}
      </div>
    </h2>
    <div class="ui form" ref="form">
      <div class="two fields">
        <div class="field">
          <label for="">{{ $t("card name") }}</label>
          <div class="ui left icon input">
            <input
              type="text"
              name="card_name"
              :placeholder="$t('card name')"
              v-model="data.card_name"
            />
            <i class="user icon"></i>
          </div>
        </div>
        <div class="field">
          <label for="">{{ $t("card number") }}</label>
          <div class="ui left icon input">
            <input
              type="text"
              name="card_number"
              :placeholder="$t('card number')"
              v-model="data.card_number"
              v-mask="'#### - #### - #### - ####'"
            />
            <i class="credit card icon"></i>
          </div>
        </div>
      </div>
      <div class="four fields">
        <div class="field">
          <label for="">{{ $t("cvv") }}</label>
          <div class="ui left icon input">
            <input
              type="text"
              name="cvv"
              :placeholder="$t('cvv')"
              v-model="data.cvv"
              v-mask="'####?'"
            />
            <i class="lock icon"></i>
          </div>
        </div>
        <div class="field">
          <label for="">{{ $t("amount") }}</label>
          <div class="ui right labeled input">
            <label for="amount" class="ui label">Q</label>
            <input
              type="text"
              name="amount"
              :placeholder="$t('amount')"
              v-model="data.amount"
              v-mask="numberMask"
            />
            <div class="ui basic label">.00</div>
          </div>
        </div>
        <div class="field">
          <label for="">{{ $t("expire date") }}</label>
          <div class="ui left icon input">
            <input
              type="text"
              name="expire_date"
              :placeholder="$t('YY/MM')"
              v-model="data.expire_date"
              v-mask="'## / ##'"
            />
            <i class="calendar icon"></i>
          </div>
        </div>
        <div class="field">
          <label for="">{{ $t("quotas available") }}</label>
          <div class="ui selection dropdown" ref="quota_dropdown">
            <input type="hidden" name="ddwn" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
      </div>
      <div class="ui icon labeled button" @click="defaultData" v-if="false">
        <i class="cog icon"></i> {{ $t("load data") }}
      </div>
      <div
        class="ui primary icon labeled button"
        @click="process_payment"
        v-bind:class="{ loading: is_loading }"
      >
        <i class="save icon"></i> {{ $t("process payment") }}
      </div>
      <div class="ui error message" ref="message"></div>
    </div>
    <div
      class="ui olive icon message"
      v-if="payment_response && !payment_error"
    >
      <i class="green check icon"></i>
      <div class="content">
        <div class="header">
          {{ $t("payment applied") }}
        </div>
        <p>
          {{ $t("thank you for your payment, it was applied successfully") }}
        </p>
      </div>
    </div>
    <div class="ui warning icon message" v-if="payment_error">
      <i class="orange remove icon"></i>
      <div class="content">
        <div class="header">
          {{ $t("an error has ocurred") }}
        </div>
        <p>
          {{ payment_error }}
        </p>
      </div>
    </div>
    <invoice
      :requestData="data"
      :dataIn="payment_response.vp"
      v-if="payment_response && payment_response.vp"
    />
  </div>
</template>

<script>
import filters from "@/filters";
import { local_api, clone, stringify /*, toast*/ } from "@/utils";
import moment from "moment";
import Invoice from "./Invoice";
import { sample, random } from "lodash";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Luhn from "luhn-js";

const currencyMask = createNumberMask({
  prefix: "",
  allowDecimal: false,
  includeThousandsSeparator: true,
  allowNegative: false,
});

// @ is an alias to /src
export default {
  name: "StudentPortalVisaPaymentIndex",
  components: { Invoice },
  filters: filters,
  data() {
    return {
      data: {
        card_name: "",
        card_number: "",
        expire_date: "",
        cvv: "",
        amount: "",
        quotas: 1,
      },
      payment_response: undefined,
      form: undefined,
      is_loading: false,
      payment_error: undefined,
      numberMask: currencyMask,
    };
  },
  computed: {
    now() {
      return moment();
    },
  },
  methods: {
    process_payment() {
      let vm = this;
      window.jQuery(vm.$refs.message).empty();
      let isValid = vm.form.form("is valid");
      if (isValid) {
        vm.is_loading = true;
        let data = clone(vm.data);
        data.amount = data.amount.replace(/,/g, "") + "00";
        data.expire_date = data.expire_date.replace(/ \/ /g, "");
        data.card_number = data.card_number.replace(/ - /g, "");
        vm.payment_error = undefined;
        local_api(vm, "post", "/student_portal/visa_payment/do-perform", {
          data: data,
        })
          .then((performResponse) => {
            // console.log(performResponse);
            // toast(document, "success", vm.$t("payment applied successfully"));
            vm.payment_response = performResponse;
            vm.is_loading = false;
          })
          .catch((err) => {
            vm.payment_response = undefined;
            vm.payment_error = err;
            console.error(err);
            vm.$alertify.error(err);
            vm.is_loading = false;
          });
      } else {
        vm.form.form("validate form");
      }
    },
    defaultData() {
      this.data = {
        card_name: "LR",
        card_number: sample([
          "4000000000000416",
          "4000000000005944",
          "2223000010025549",
        ]),
        expire_date: "2401",
        cvv: "123",
        amount: random(100, 1000, false),
      };
    },
  },
  created() {},
  mounted() {
    // window.jQuery(this.$refs.expire_date).calendar({
    //   type: "month",
    // });
    let vm = this;

    window.jQuery.fn.form.settings.rules.luhnCreditCard = function(value) {
      let rawValue = value.replace(/-/g, "").replace(/ /g, "");
      if (rawValue) return Luhn.isValid(rawValue);
      else return false;
    };

    window.jQuery.fn.form.settings.rules.expirationDate = function(value) {
      let rawValue = value.replace(/ /g, "");
      let splitted = rawValue.split("/");
      let year = splitted[0];
      let month = splitted[1];
      if (Number(year) < moment().format("YY")) return false;
      if (Number(month) >= 1 && Number(month) <= 12) return true;
      return false;
    };

    this.form = window.jQuery(this.$refs.form).form({
      fields: {
        card_name: {
          identifier: "card_name",
          rules: [
            {
              type: "empty",
              prompt: vm.$t("enter credit card name"),
            },
          ],
        },
        card_number: {
          identifier: "card_number",
          rules: [
            { type: "empty", prompt: vm.$t("enter credit card number") },
            {
              type: "regExp[/^[0-9]{4} - [0-9]{4} - [0-9]{4} - [0-9]{4}$/]",
              prompt: vm.$t("enter a valid credit card"),
            },
            {
              type: "luhnCreditCard",
              prompt: vm.$t("enter a valid credit card number"),
            },
          ],
        },
        cvv: {
          identifier: "cvv",
          rules: [
            {
              type: "empty",
              prompt: vm.$t("enter cvv"),
            },
          ],
        },
        amount: {
          identifier: "amount",
          rules: [
            {
              type: "empty",
              prompt: vm.$t("enter amount"),
            },
          ],
        },
        expire_date: {
          identifier: "expire_date",
          rules: [
            { type: "empty", prompt: vm.$t("enter expire date") },
            { type: "expirationDate", prompt: vm.$t("expire date invalid") },
          ],
        },
      },
    });

    local_api(this, "post", "/student_portal/visa_payment/do-get-configuration")
      .then((conf) => {
        if (conf && conf.setup && conf.setup.quotas_available) {
          let qts = conf.setup.quotas_available
            .split(",")
            .map((r) => {
              return Number(r);
            })
            .sort((a, b) => {
              if (a < b) return -1;
              else if (a > b) return 1;
              else if (a == b) return 0;
            });
          window
            .jQuery(vm.$refs.quota_dropdown)
            .dropdown("setup menu", {
              values: qts.map((q) => {
                return { name: q, value: q };
              }),
            })
            .dropdown("set selected", 1)
            .dropdown({
              onChange(value) {
                vm.data.quotas = value;
              },
            });
        }
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
  watch: {},
};
</script>

<style></style>
